import {
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';
import languagesPropType from './languagesPropType.js';
import translate from './translate.js';

class ConfirmPasswordFormField extends React.Component {
  validatePasswordsMatch = () => {
    let {
      language,
      newPassword,
      value,
    } = this.props;

    return newPassword === value
      ? null
      : translate('passwordsDoNotMatch', language);
  }

  handleChangePassword = (e) => this.props.onChange(e.target.value);

  render() {
    let {
      formFieldProps,
      inputProps,
      label,
      language,
      onSetValidate,
      value,
    } = this.props;

    return (
      <FormField
        className="tall-form-group"
        isRequired
        isRequiredErrorMessage={translate('confirmPasswordRequired', language)}
        label={label ? label : translate('confirmPassword', language)}
        validate={[
          this.validatePasswordsMatch,
        ]}
        ref={ref => {
          if (ref) {
            onSetValidate(() => ref.validate());
          }
        }}
        value={value}
        {...formFieldProps}
      >
        <FormControl
          name="confirm-password"
          onChange={this.handleChangePassword}
          type="password"
          value={value}
          {...inputProps}
        />
      </FormField>
    );
  }
}

ConfirmPasswordFormField.defaultProps = {
  formFieldProps: {},
  inputProps: {},
  language: languagesPropType.defaultProp,
  onSetValidate: () => {},
  value: '',
};

ConfirmPasswordFormField.propTypes = {
  formFieldProps: PropTypes.object,
  inputProps: PropTypes.object,
  label: PropTypes.node,
  language: languagesPropType.propType,
  newPassword: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSetValidate: PropTypes.func,
  value: PropTypes.string.isRequired,
};

export default ConfirmPasswordFormField;